import { FetchesData } from "kinnect-mixins";
import { KForm, KSelect, KTextField } from "kinnect-general";
import { YardTruckType } from "kinnect-models";

export default KForm.extend( {
	name: "KTruckForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "yardTrucks" } ]
		},

		truck: Object
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			imei: "",
			number: "",
			type: null,
			vin: ""
		},
		truckTypes: []
	} ),

	computed: {
		editing() {
			return Boolean( this.truck );
		},

		formUrl() {
			return this.editing
				? `yard/trucks/${this.truck.id}`
				: "yard/trucks";
		}
	},

	watch: {
		truck: {
			handler( truck ) {
				if ( truck ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( truck.hasOwnProperty( key ) ) {
							this.formFields[key] = truck[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		async fetchTruckTypes() {
			this.truckTypes = await YardTruckType.get();
		},

		async fetch() {
			await this.fetchTruckTypes();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KSelect
				itemText="name"
				itemValue="id"
				items={this.truckTypes}
				label="Truck Type*"
				loading={this.$wait.is( "get truck types" )}
				prependIcon="local_shipping"
				required
				vModel={this.formFields.type}
				validationName="truck type"
				validationRules="required"
			></KSelect>

			<KTextField
				class="ml-blank-icon"
				label="Kinnunen Truck Number*"
				required
				vModel={this.formFields.number}
				validationName="Kinnunen truck number"
				validationRules="required|numeric"
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Linxup Device IMEI*"
				required
				vModel={this.formFields.imei}
				validationName="Linxup device IMEI"
				validationRules="required|numeric"
			></KTextField>

			<KTextField
				class="ml-blank-icon"
				label="Truck VIN Number*"
				required
				vModel={this.formFields.vin}
				validationName="Truck VIN Number"
				validationRules="required|alpha_num"
			></KTextField>
		</KForm>;
	}
} );
